import * as Blockly from 'blockly/core';
import { blockFor } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

let _forCounter = 0;

export function resetForCounter(): void {
    _forCounter = 0;
}

export function register(gen: any): void {
    gen.forBlock['for'] = function (block: Blockly.Block): string {
        const varName = `_i${_forCounter++}`;
        const count = gen.valueToCode(block, 'COUNT', 0) || '0';
        const body = gen.statementToCode(block, 'DO');
        return blockFor(`int ${varName} = 0`, `${varName} < ${count}`, `${varName}++`, body);
    };
}
